import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  const stats = [
    { value: "€1.4T", key: "hero_stat_assets" },
    { value: "9,000+", key: "hero_stat_companies" },
    { value: "70+", key: "hero_stat_countries" },
    { value: "35", key: "hero_stat_years" },
  ];

  return (
    <section id="home" className="relative min-h-screen flex flex-col">
      <div className="absolute inset-0 w-full h-full">
        <img
          alt="Happy pensioners"
          className="w-full h-full object-cover object-center"
          src="https://public.readdy.ai/ai/img_res/67b331b318f7c266d2d720a9e9c9af95.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-950/60 via-gray-900/40 to-gray-950/80 md:hidden"></div>
        <div className="absolute inset-0 hidden md:block bg-gradient-to-r from-gray-950/85 via-gray-900/60 to-gray-900/20"></div>
      </div>

      <div className="relative z-10 flex-1 flex flex-col justify-end md:justify-center max-w-7xl mx-auto px-4 md:px-6 w-full pt-24 pb-10 md:pb-16">
        <div className="max-w-2xl w-full">
          <div className="inline-flex items-center gap-2 bg-emerald-700/30 border border-emerald-500/40 text-emerald-300 text-xs font-semibold px-3 py-1.5 md:px-4 md:py-2 rounded-full mb-4 backdrop-blur-sm">
            <i className="ri-shield-star-line"></i>
            {t("hero_badge")}
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white leading-tight mb-3">
            {t("hero_title_1")}<br />
            <span className="text-emerald-400 italic">{t("hero_title_2")}</span> {t("hero_title_3")}
          </h1>
          <p className="text-sm md:text-lg text-white/80 mb-6 leading-relaxed max-w-xl">
            {t("hero_desc")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mb-8">
            <a
              href="#investment-slider"
              className="bg-emerald-700 hover:bg-emerald-600 text-white font-semibold px-6 py-3.5 md:px-8 md:py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm md:text-base w-full sm:w-auto text-center"
            >
              {t("hero_cta_calc")}
            </a>
            <a
              href="#about"
              className="border border-white/50 text-white hover:bg-white/10 font-semibold px-6 py-3.5 md:px-8 md:py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm md:text-base backdrop-blur-sm w-full sm:w-auto text-center"
            >
              {t("hero_cta_learn")}
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-6">
            {stats.map((stat) => (
              <div key={stat.key} className="bg-white/10 backdrop-blur-sm rounded-xl p-3 sm:p-0 sm:bg-transparent">
                <div className="text-lg md:text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/60 mt-0.5">{t(stat.key)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 flex justify-center pb-5">
        <a href="#about" className="text-white/50 hover:text-white/80 transition-colors cursor-pointer animate-bounce">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}
